import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import PropTypes from 'prop-types';
import 'antd/dist/antd.min.css';
import {
  UserOutlined,
  LogoutOutlined,
  // QuestionCircleOutlined,
  // ArrowLeftOutlined,
  EditOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';
import {
  Row,
  Col,
  Button,
  Tag,
  Layout,
  Avatar,
  Drawer,
  Typography,
  message,
} from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import { getRoutes } from 'routes/index';
import { TOGGLE_SIDEBAR, CLEAN } from 'store/reducers/app';
import { onError } from 'utils/handlers';
import { LOGOUT } from 'store/reducers/auth';
import { CLEAR } from 'store/reducers/catalogs';
import { CLEAN_CAJA } from 'store/reducers/caja';
import { CLEAN_DASHBOARD } from 'store/reducers/dashboard';
import ModalCorteControls from 'views/Recaudacion/Caja/ModalCorteControls';
import GlobalStyles from 'themes/global';
import { defSigob } from 'themes';
import fullNameUser from 'utils/fullNameUser';
import { foo } from 'mocks/hardcodedStuff';
import Breadcrumb from './Breadcrumb';
import Footer from './Footer';
import ThemeConfig from './ThemeConfig';
import LayoutHeader from './LayoutHeader';
import ModalChangePassword from './ModalChangePassword';
import ModalChangeFiscalPeriod from './ModalChangeFiscalPeriod';
import Menu from './Menu';
import './index.scss';

const ENV_NAME = process.env.REACT_APP_ENV_NAME;
const REPUVE = ENV_NAME === 'repuve';
const ARCOS = ENV_NAME === 'arcos';
const FINANZAS = ENV_NAME === 'nayarit';
const { Content, Sider } = Layout;
const { Text } = Typography;

const AppLayout = ({ children }) => {
  const dispatch = useDispatch();
  const { user, roles, periodoFiscalSelected } = useSelector(({ auth }) => auth);
  const { theme, collapsedSidebar } = useSelector(({ app }) => app);
  const history = useHistory();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(collapsedSidebar);
  const [isMobile, setIsMobile] = useState(false);

  const [visibleDrawer, setVisibleDrawer] = useState(false);
  const [visiblePassword, setVisiblePassword] = useState(false);

  const [margin, setMargin] = useState();
  const [drawerContent, setDrawerContent] = useState();
  const [drawerTitle, setDrawerTitle] = useState();
  const [collapsedWidth, setCollapsedWidth] = useState(80);

  const constrasenaModificada = user?.modifico_contrasena;
  // const REPUVE = process.env.REACT_APP_ENV_NAME ==='repuve';

  let currentPath = location.pathname;
  const split = currentPath.split('/').filter((x) => x.length);
  currentPath = split.map((s, is) => `/${split.filter((a, i) => i <= is).join('/')}`);

  const splicedSplit = [...split];
  splicedSplit.splice(0, 2);

  const content = (
    <>
      <Row justify="end">
        <Button
          type="link"
          style={{ color: '#000000', marginTop: -25 }}
          icon={<CloseCircleOutlined />}
          onClick={() => message.destroy()}
        />
      </Row>
      <strong>Mensaje Importante.</strong>
      <br />
      Es importante que mantengas tu Clave, bajo la más absoluta confidencialidad
      y en ningún caso debes revelarla o compartirla con otras personas
    </>
  );

  useEffect(() => {
    if (!constrasenaModificada && FINANZAS && process.env.REACT_APP_ENV !== 'DEV') {
      setVisiblePassword(true);
      message.info({ content, duration: 0 });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isMobile) {
      setMargin(0);
      setCollapsedWidth(0);
      setCollapsed(true);
      dispatch({
        type: TOGGLE_SIDEBAR,
        payload: true,
      });
    } else {
      setMargin(collapsedSidebar ? 80 : 300);
      setCollapsedWidth(80);
      dispatch({
        type: TOGGLE_SIDEBAR,
        payload: false,
      });
    }
    // eslint-disable-next-line
  }, [isMobile]);
  const hasInfoToDisplay = !!(user.unidad_responsable || user.unidad_operativa
    || user.funcionario?.puesto || user.funcion_del_usuario_externo || user.justificacion);

  const User = () => (
    <div className="user-info">
      <Row>
        <Row className="avatar-wrapper">
          {/* eslint-disable-next-line no-use-before-define */}
          {UserAvatar(false)}
        </Row>
        <Col
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Text strong>
            {fullNameUser(user)}
          </Text>
          <Text>
            {user.email}
          </Text>
          {!!roles?.length && (
            <Col className="card">
              <Text style={{
                fontSize: 16,
                marginBottom: 5,
              }}
              >
                Roles
              </Text>
              <Row>
                {roles.map((role) => (
                  <Tag key={role.id}>
                    {role.name.split('-').shift().trim()}
                  </Tag>
                ))}
              </Row>
            </Col>
          )}

          <Col className="card">
            {hasInfoToDisplay && (
              <Text style={{ fontSize: 16, marginBottom: 5 }}>
                Información del usuario
              </Text>
            )}
            {(REPUVE || ARCOS) && user.centro_de_costos && (
              <Text>
                Oficina:
                {' '}
                {user.centro_de_costos.descripcion}
              </Text>
            )}
            {!REPUVE && !ARCOS && user.unidad_responsable && (
              <Text>
                Departamento:
                {' '}
                {user.unidad_responsable.descripcion}
              </Text>
            )}
            {user.unidad_operativa && !user.unidad_responsable && (
              <Text>
                Dependencia:
                {' '}
                {user.unidad_operativa.descripcion}
              </Text>
            )}
            {user.funcionario?.puesto && (
              <Text>
                Puesto:
                {' '}
                {user.funcionario.puesto?.descripcion}
              </Text>
            )}
            {user.funcion_del_usuario_externo && (
              <Text>
                Función:
                {' '}
                {user.funcion_del_usuario_externo?.descripcion}
              </Text>
            )}
            {user.justificacion && (
              <Text>
                Justificación:
                {' '}
                {user.justificacion?.descripcion}
              </Text>
            )}
          </Col>

          <Row className="card">
            <Button
              type="link"
              href="/configuracion/cuenta-de-usuario"
            >
              <UserOutlined />
              Perfil de Usuario
            </Button>
            <Button
              type="link"
              className="update-password no-color"
              onClick={() => {
                setVisiblePassword(true);
                setVisibleDrawer(false);
              }}
            >
              <EditOutlined />
              Actualizar Contraseña
            </Button>
            <Button
              type="link"
              danger
              className="logout no-color"
              onClick={() => {
                dispatch({ type: LOGOUT });
                dispatch({ type: CLEAN });
                dispatch({ type: CLEAR });
                dispatch({ type: CLEAN_CAJA });
                dispatch({ type: CLEAN_DASHBOARD });
                history.push('/');
              }}
            >
              <LogoutOutlined />
              Cerrar sesión
            </Button>
          </Row>
          <br />
          <br />
          {periodoFiscalSelected && (
            <Text>
              <ModalChangeFiscalPeriod />
            </Text>
          )}
          <Text>
            Ver.
            {process.env.REACT_APP_VERSION}
          </Text>
        </Col>
      </Row>
    </div>
  );

  const onClickAvatar = () => {
    setDrawerContent(User);
    setDrawerTitle('Usuario');
    setVisibleDrawer(true);
  };

  const onClickSetting = () => {
    setDrawerContent(<ThemeConfig onError={onError} />);
    setVisibleDrawer(true);
    setDrawerTitle('Configuración de tema');
  };

  const notifications = () => (foo.map((item) => (
    <Row
      key={item.key}
      className={`notification-item ${item.readed ? 'readed' : ''}`}
    >
      <Col>
        <Text style={{ color: '#000' }} strong>
          {item.title}
        </Text>
        <br />
        <Text>
          {item.content}
        </Text>
        <br />
        <Text>{item.date}</Text>
      </Col>
    </Row>
  )));

  const onClickNotifications = () => {
    setDrawerContent(notifications);
    setDrawerTitle('Notificaciones');
    setVisibleDrawer(true);
  };

  const UserAvatar = () => {
    <Avatar
      src={user?.foto}
      icon={user?.foto ? null : <UserOutlined />}
      size="large"
    />;
  };

  const toggle = () => {
    setCollapsed(!collapsed);
    dispatch({
      type: TOGGLE_SIDEBAR,
      payload: !collapsed,
    });
    if (isMobile) {
      setMargin(0);
      setCollapsedWidth(0);
    } else {
      setMargin(!collapsed ? 80 : 300);
      setCollapsedWidth(!collapsed ? 80 : 300);
    }
  };

  const routes = useMemo(() => {
    const _routes = getRoutes();
    return (periodoFiscalSelected?.vigente || ENV_NAME === 'repuve')
      ? _routes : _routes.filter((e) => e.title !== 'Recaudación');
  }, [user.permisos, periodoFiscalSelected]);

  return (
    <ThemeProvider
      theme={theme || defSigob}
    >
      <GlobalStyles />
      <Layout>
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          collapsedWidth={collapsedWidth}
          id="left-sider"
          theme="dark"
          width={300}
          breakpoint="md"
          onBreakpoint={(broken) => {
            setIsMobile(broken);
          }}
          style={{
            position: 'absolute',
            top: 64,
            left: 0,
          }}
        >
          <Menu
            routes={routes}
            defaultSelectedKeys={currentPath}
            collapsedSidebar={collapsedSidebar}
          />
        </Sider>
        <Layout
          className="site-layout"
          style={{ marginLeft: collapsed ? margin : 300, transition: 'all 0.2s' }}
        >
          <LayoutHeader
            isMobile={isMobile}
            toggle={toggle}
            collapsed={collapsed}
            onClickAvatar={onClickAvatar}
            onClickNotifications={onClickNotifications}
            onClickSetting={onClickSetting}
          />
          <Content
            style={{
              left: margin,
              width: `calc(100vw - ${margin}px)`,
              padding: '15px 25px 0 25px',
            }}
          >
            <Breadcrumb
              routes={routes}
              isMobile={isMobile}
            />
            <div
              className="customCard"
              style={{
                height: `calc(100vh - ${isMobile ? 140 : 175}px)`,
                overflowY: 'scroll',
                minHeight: 230,
              }}
            >
              {children}
            </div>
            <Footer editable={!REPUVE} margin={margin} onError={onError} />
          </Content>
          <Drawer
            id="layot-drawer"
            title={drawerTitle}
            placement="right"
            width={isMobile ? '100%' : 400}
            destroyOnClose
            onClose={() => {
              setVisibleDrawer(false);
            }}
            visible={visibleDrawer}
            closable
          >
            {drawerContent}
          </Drawer>
        </Layout>
      </Layout>
      <ModalChangePassword
        onError={onError}
        visible={visiblePassword}
        setVisible={setVisiblePassword}
      />
      <ModalCorteControls />
      {/* <Help /> */}
    </ThemeProvider>
  );
};

AppLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppLayout;
